import React from 'react';
import { compose, withPropsOnChange, branch, renderComponent } from 'recompose';

import { Slider } from 'components/core/Slider';
import { FacilityImage } from 'components/facility/FacilityImage';

export const enhance = compose(
	withPropsOnChange(['facility'], ({ facility, images, size }) => ({
		className: 'facility-image-carousel',
		children: images.map((image, index) => (
			<FacilityImage
				key={image}
				src={image}
				size={size}
				alt={`${facility.name} ${facility.location.streetAddress1} ${facility.location.city}, ${facility.location.state} - Photo ${index}`}
				lazyLoad={true}
			/>
		)),
	})),
	branch(
		({ children }) => !children || !children.length,
		renderComponent(FacilityImage),
	),
);

export default enhance(Slider);
